export class ViewApplicationContentMenuConstants {
    static APPLICATION_WITHDRAWAL_REASON = "Manual Termination of Job";
    static WITHDRAW_BTN_PLACEHOLDER = "Withdraw Application";
    static CONFIRM_DIALOG_BODY = "Are you sure you want to withdraw this application?";
    static WORKFLOW_STEP_TYPE_END = "End";
}
